// ============================================================================
// CART SOURCE TRACKING
// ----------------------------------------------------------------------------
// Every cart add gets two hidden line item properties so we can attribute
// orders in the admin/GraphQL:
//
//   _source — which button / app added the item
//   _page   — URL path the user was on when it happened (e.g. /collections/foo)
//
// Leading underscore = hidden from customer-facing cart/checkout/emails but
// persisted on the order. Queryable via Admin GraphQL lineItems.customAttributes.
// NOT queryable via Shopify admin Orders search (admin search rejects
// line_items.properties.*) — use GraphQL or saved filter views.
//
// _source vocabulary:
//   THEME_atc     — theme Add to Cart form (product or collection card)
//   THEME_bn      — theme Buy Now button (this file, below)
//   THEME_qb      — theme Quick Buy button (snippets/quick-buy-button.liquid)
//   EP_addon      — Essential Products PRODUCT_ADDON checkbox item
//   EP_target     — Essential Products FBT main product (Claim Offer button)
//   EP_bundled    — Essential Products FBT bundle partner (non-target item)
//
// Naming rule: THEME_* = native theme button; EP_* = attributable to the
// Essential Products app; future apps follow XX_* pattern.
//
// *** FIVE IMPLEMENTATION SITES — change the shape, update all five: ***
//
//   1. snippets/product__form.liquid      — hidden inputs (ATC, product page)
//   2. snippets/quickAddToCartForm.liquid — hidden inputs (ATC, collection card)
//   3. snippets/quick-buy-button.liquid   — inline in $.ajax data payload (QB)
//   4. assets/custom.js (below)           — inline in Buy Now payload (BN)
//   5. assets/custom.js (EPA wrapper)     — window.fetch wrapper tags EP_*
//
// Why five sites:
//   • THEME_atc uses static Liquid hidden inputs because $form.serialize() in
//     z__jsAjaxCart.js picks them up automatically — no JS required, and the
//     stable XHR submit flow stays untouched.
//   • THEME_bn and THEME_qb use JS payloads because those handlers build the
//     fetch body themselves (they don't go through a <form>).
//   • EP_* is tagged via a window.fetch wrapper because EPA is a theme app
//     extension — it calls /cart/add.js from its own compiled bundle, no theme
//     code runs. The wrapper inspects __essential_upsell_* markers on items to
//     distinguish target / addon / bundled. Theme buttons use jQuery $.ajax
//     (XHR, not fetch), so the wrapper is invisible to them — that's why
//     ATC/BN/QB tag themselves directly.
//
// Inlined intentionally — no shared helper. Previously had window.cartSource()
// but QB (in a separate file) gained a cross-file dependency on custom.js
// parsing correctly, which was a new regression risk. Inlining is cheap, the
// shape is stable, and each call site reads as what it sends.
// ============================================================================ 


// Buy Now: monogram validated here directly (see monogram-input.liquid for full strategy)
$(document).on("click","[data-buy-now]",function(e){
  e.preventDefault();
  var id = $(this).attr("data-id");
  var monogramInput = document.querySelector('[data-monogram-input]');
  // Block if monogram exists but is empty
  if (monogramInput && monogramInput.value.length === 0) {
    monogramInput.focus();
    monogramInput.classList.add('monogram-input__field--error');
    var errorMsg = document.querySelector('[data-monogram-error]');
    if (errorMsg) errorMsg.style.visibility = 'visible';
    return false;
  }
  var payload = {
    id: id,
    quantity: 1,
    properties: { _source: 'THEME_bn', _page: window.location.pathname }
  };
  if (monogramInput && monogramInput.value) {
    payload.properties.Monogram = monogramInput.value;
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify(payload),
    contentType: 'application/json',
    dataType: 'json',
    success: function(cartData) {
      window.location.href = '/checkout';
    },
    error: function(xhr, status, error) {
      console.log(error);
    }
  });
});

// EPA cart-source tagging. Wraps window.fetch to tag Essential Products
// upsell items (EP_target / EP_addon / EP_bundled). See header comment at
// top of file for the full system. Installs AFTER EPA — EPA's guard only
// checks its own flag, so if we patch first it overwrites us. Polls for
// window._essentialUpsellFetchOverridden up to 2s, then installs anyway
// (wrapper is a no-op on pages with no EP markers, so fallback is safe).
// Every operation wrapped in try/catch — on ANY error, falls through to
// the original unmodified fetch. Never breaks a cart add.
(function installCartFetchWrapper() {
  function install() {
    var prevFetch = window.fetch;
    window.fetch = function(resource, init) {
      try {
        var url = (resource && resource.url) || String(resource || '');
        if (!/\/cart\/add\.js(\?|$)/.test(url)) return prevFetch.apply(this, arguments);
        if (!init || typeof init.body !== 'string') return prevFetch.apply(this, arguments);
        var body = JSON.parse(init.body);
        var page = window.location.pathname;
        var items = Array.isArray(body.items) ? body.items : (body.id ? [body] : null);
        if (!items) return prevFetch.apply(this, arguments);
        var hasFbtTarget = items.some(function(it) {
          return it && it.properties && it.properties.__essential_upsell_is_target_product;
        });
        items.forEach(function(item) {
          item.properties = item.properties || {};
          if (item.properties._source) return;
          var isTarget = !!item.properties.__essential_upsell_is_target_product;
          var hasFunnelId = !!item.properties.__essential_upsell_funnel_id;
          if (!isTarget && !hasFunnelId) return;
          if (isTarget) item.properties._source = 'EP_target';
          else if (hasFbtTarget) item.properties._source = 'EP_bundled';
          else item.properties._source = 'EP_addon';
          item.properties._page = page;
        });
        var newInit = Object.assign({}, init, { body: JSON.stringify(body) });
        return prevFetch.call(this, resource, newInit);
      } catch (err) {
        return prevFetch.apply(this, arguments);
      }
    };
  }
  if (window._essentialUpsellFetchOverridden) return install();
  var tries = 0;
  var timer = setInterval(function() {
    if (window._essentialUpsellFetchOverridden || ++tries > 40) {
      clearInterval(timer);
      install();
    }
  }, 50);
})();

/*
 * Judge.me Review Pinning
 * Runs on any product page where the current product has UUIDs in
 * custom.judgeme_pinned_reviews. Finds whatever Judge.me review widget
 * is on the page, fetches that widget's product's reviews, and pins
 * reviews whose UUIDs match the metafield. UUIDs that don't match
 * any review in the widget's pool are silently ignored.
 */
(function() {
  // --- CONFIG ---
  var PINNED_IDS = window.__jdgmPinnedReviews || [];
  var PER_PAGE = 5;
  var API_PER_PAGE = 30;
  var SHOP_DOMAIN = 'icemadeclear.myshopify.com';
  // --- END CONFIG ---

  if (!PINNED_IDS.length) return;

  var widget = document.querySelector('.jdgm-review-widget[data-id]');
  if (!widget) return;
  var PRODUCT_ID = widget.getAttribute('data-id');
  if (!PRODUCT_ID) return;

  var reviewsContainer = widget.querySelector('.jdgm-rev-widg__reviews');
  var paginateContainer = widget.querySelector('.jdgm-paginate');
  if (!reviewsContainer) return;

  // Hide reviews immediately to prevent flash
  reviewsContainer.style.visibility = 'hidden';
  if (paginateContainer) paginateContainer.style.visibility = 'hidden';

  var apiBase = 'https://api.judge.me/reviews/reviews_for_widget'
    + '?url=' + SHOP_DOMAIN
    + '&shop_domain=' + SHOP_DOMAIN
    + '&platform=shopify'
    + '&per_page=' + API_PER_PAGE
    + '&product_id=' + PRODUCT_ID;

  // Fetch page 1 first to get total count
  fetch(apiBase + '&page=1')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var totalPages = Math.ceil(data.total_count / API_PER_PAGE);
      var fetches = [Promise.resolve(data)];
      for (var i = 2; i <= totalPages; i++) {
        fetches.push(fetch(apiBase + '&page=' + i).then(function(r) { return r.json(); }));
      }
      return Promise.all(fetches);
    })
    .then(function(pages) {
      // Parse all reviews from all pages
      var allReviews = [];
      pages.forEach(function(page) {
        var temp = document.createElement('div');
        temp.innerHTML = page.html;
        var revs = temp.querySelectorAll('.jdgm-rev');
        for (var i = 0; i < revs.length; i++) {
          allReviews.push(revs[i]);
        }
      });

      // Separate pinned from unpinned, preserving pin order
      var pinned = [];
      var unpinned = [];
      PINNED_IDS.forEach(function(id) {
        for (var i = 0; i < allReviews.length; i++) {
          if (allReviews[i].getAttribute('data-review-id') === id) {
            pinned.push(allReviews[i]);
            break;
          }
        }
      });
      allReviews.forEach(function(rev) {
        var id = rev.getAttribute('data-review-id');
        if (PINNED_IDS.indexOf(id) === -1) {
          unpinned.push(rev);
        }
      });

      // Default-sort unpinned group by most-recent so Judge.me-side
      // pinned reviews don't stay at the top by API-response order.
      unpinned.sort(function(a, b) {
        return (b.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '')
          .localeCompare(a.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '');
      });

      var ordered = pinned.concat(unpinned);

      // Store for sorting
      widget._allReviews = ordered;
      widget._pinnedIds = PINNED_IDS;

      renderPage(widget, 1);

      // Intercept sort dropdown (hidden but preserved for future use)
      var sortDropdown = widget.querySelector('.jdgm-sort-dropdown');
      if (sortDropdown) {
        sortDropdown.addEventListener('change', function(e) {
          e.stopImmediatePropagation();
          var sortVal = sortDropdown.value;
          sortReviews(widget, sortVal);
          renderPage(widget, 1);
        }, true);
      }
    })
    .catch(function() {
      // Fallback: just show default Judge.me render
      reviewsContainer.style.visibility = '';
      if (paginateContainer) paginateContainer.style.visibility = '';
    });

  function sortReviews(widget, sortVal) {
    var pinned = [];
    var unpinned = [];
    widget._allReviews.forEach(function(rev) {
      var id = rev.getAttribute('data-review-id');
      if (widget._pinnedIds.indexOf(id) !== -1) {
        pinned.push(rev);
      } else {
        unpinned.push(rev);
      }
    });

    // Sort unpinned only — pinned stay in config order
    unpinned.sort(function(a, b) {
      switch (sortVal) {
        case 'highest-rating':
          return parseInt(b.querySelector('[data-score]').getAttribute('data-score'))
               - parseInt(a.querySelector('[data-score]').getAttribute('data-score'));
        case 'lowest-rating':
          return parseInt(a.querySelector('[data-score]').getAttribute('data-score'))
               - parseInt(b.querySelector('[data-score]').getAttribute('data-score'));
        case 'most-recent':
          return (b.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '')
            .localeCompare(a.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '');
        case 'with-pictures':
        case 'pictures-first':
          var aPics = a.querySelectorAll('.jdgm-rev__pic-img').length;
          var bPics = b.querySelectorAll('.jdgm-rev__pic-img').length;
          if (sortVal === 'with-pictures') {
            return bPics - aPics;
          }
          if (bPics !== aPics) return bPics - aPics;
          return (b.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '')
            .localeCompare(a.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '');
        case 'videos-first':
          var aVids = a.querySelectorAll('.jdgm-rev__vid').length;
          var bVids = b.querySelectorAll('.jdgm-rev__vid').length;
          if (bVids !== aVids) return bVids - aVids;
          return (b.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '')
            .localeCompare(a.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '');
        case 'most-helpful':
          var aUp = parseInt(a.getAttribute('data-thumb-up-count') || 0);
          var bUp = parseInt(b.getAttribute('data-thumb-up-count') || 0);
          return bUp - aUp;
        default:
          return 0;
      }
    });

    // Re-sort pinned to match config order
    pinned.sort(function(a, b) {
      return widget._pinnedIds.indexOf(a.getAttribute('data-review-id'))
           - widget._pinnedIds.indexOf(b.getAttribute('data-review-id'));
    });

    widget._allReviews = pinned.concat(unpinned);
  }

  function renderPage(widget, page) {
    var reviews = widget._allReviews;
    var total = reviews.length;
    var totalPages = Math.ceil(total / PER_PAGE);
    var start = (page - 1) * PER_PAGE;
    var end = Math.min(start + PER_PAGE, total);

    var container = widget.querySelector('.jdgm-rev-widg__reviews');
    container.innerHTML = '';
    for (var i = start; i < end; i++) {
      var clone = reviews[i].cloneNode(true);
      var revId = clone.getAttribute('data-review-id');

      // Strip any pre-existing pin indicator — metafield is the sole source of truth
      var existingPin = clone.querySelector('.jdgm-rev__pinned');
      if (existingPin) existingPin.parentNode.removeChild(existingPin);
      clone.classList.remove('jdgm-rev--pinned');

      // Add our pin indicator only if this review is in the metafield list
      if (PINNED_IDS.indexOf(revId) !== -1) {
        var pinSpan = document.createElement('span');
        pinSpan.className = 'jdgm-rev__pinned';
        var timestamp = clone.querySelector('.jdgm-rev__timestamp');
        if (timestamp) {
          timestamp.parentNode.insertBefore(pinSpan, timestamp.nextSibling);
        }
      }
      container.appendChild(clone);
    }

    // Build pagination
    var paginate = widget.querySelector('.jdgm-paginate');
    if (!paginate) {
      paginate = document.createElement('div');
      paginate.className = 'jdgm-paginate';
      paginate.setAttribute('data-per-page', PER_PAGE);
      container.parentNode.insertBefore(paginate, container.nextSibling);
    }
    paginate.innerHTML = '';

    if (totalPages <= 1) {
      paginate.style.display = 'none';
    } else {
      paginate.style.display = '';

      // First/prev
      if (page > 1) {
        paginate.appendChild(makePageLink(widget, 1, 'jdgm-paginate__first-page'));
        paginate.appendChild(makePageLink(widget, page - 1, 'jdgm-paginate__prev-page', 'prev'));
      }

      // Page numbers (show max 5 around current)
      var startPage = Math.max(1, page - 2);
      var endPage = Math.min(totalPages, page + 2);
      for (var p = startPage; p <= endPage; p++) {
        var cls = p === page ? 'jdgm-curt' : '';
        paginate.appendChild(makePageLink(widget, p, cls, null, p));
      }

      // Next/last
      if (page < totalPages) {
        paginate.appendChild(makePageLink(widget, page + 1, 'jdgm-paginate__next-page', 'next'));
        paginate.appendChild(makePageLink(widget, totalPages, 'jdgm-paginate__last-page'));
      }
    }

    container.style.visibility = '';
    paginate.style.visibility = '';

    // Re-init Judge.me (timestamps, verified badges, avatars, layout)
    if (window.jdgm) {
      try { if (jdgm.customizeReviews) jdgm.customizeReviews(); } catch(e) {}
      // Lazy-load review photos (unveil doesn't re-trigger without this)
      if (jdgm.jQuery && jdgm.setupLazyLoadPicture) {
        try { jdgm.setupLazyLoadPicture(jdgm.jQuery(container).find('.jdgm-rev__pic-img')); } catch(e) {}
      }
    }


    // Scroll to widget top on page change (except first load)
    if (page > 1 || widget._hasRendered) {
      widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    widget._hasRendered = true;
  }

  function makePageLink(widget, page, extraClass, rel, label) {
    var a = document.createElement('a');
    a.className = 'jdgm-paginate__page ' + (extraClass || '');
    a.setAttribute('data-page', page);
    a.setAttribute('aria-label', 'Page ' + page);
    a.setAttribute('tabindex', '0');
    a.setAttribute('role', 'button');
    if (rel) a.setAttribute('rel', rel);
    if (label) a.textContent = label;
    a.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      renderPage(widget, page);
    });
    return a;
  }
})();